import { GenericBaseRequest } from './generic-base.request';

export class UpdatePasswordRequest extends GenericBaseRequest {
  platform: number = 9;
  codigo: string;
  password: string;
  uuid: string = '';
  description: string = '';

  constructor() {
    super();
    this.platform = 9; //PIX
  }
}
